import { handle } from 'redux-pack';
import { logUncaught } from 'utils/log';

export const updateIssueReportError = ({ state, action: { hasReportError } }) => ({
  ...state,
  hasReportError,
});

export const updateDialogLoadingState = (prevState) => ({
  ...prevState,
  isDialogLoading: true,
});

export const updateIssueReportState = (prevState, action, error) => {
  if (error) {
    const statusCodes = action.payload.response && action.payload.response.status;

    logUncaught(
      new Error('[Failure reporting issue]'),
      {
        state: prevState,
        payload: action.payload,
      }
    );

    return statusCodes === 403
      ? {
        ...prevState,
        isDialogLoading: false,
      }
      : {
        ...prevState,
        hasReportError: true,
        isDialogLoading: false,
      };
  }

  return {
    ...prevState,
    isIssueReported: true,
    isDialogLoading: false,
  };
};

export const handleIssueReportLifecycle = (action) => ({
  start: (prevState) => updateDialogLoadingState(prevState),
  success: (prevState) => updateIssueReportState(prevState, action, false),
  failure: (prevState) => updateIssueReportState(prevState, action, true),
});

export const handleIssueReport = (state, action) =>
  handle(state, action, handleIssueReportLifecycle(action));
